// documents.ts — Patch 010.A.4 R7 split. Patch 012.A.1 document upload API.

import { ApiError, BASE, request } from './request'
import type { DocumentRow } from './types'

export const documentsApi = {
  list: (projectId: string, params?: { documentType?: string; includeArchived?: boolean }) => {
    const q: string[] = []
    if (params?.documentType) q.push(`document_type=${encodeURIComponent(params.documentType)}`)
    if (params?.includeArchived) q.push('include_archived=true')
    const qs = q.length > 0 ? `?${q.join('&')}` : ''
    return request<{ ok: true; documents: DocumentRow[]; count: number }>(
      `/api/projects/${encodeURIComponent(projectId)}/documents${qs}`,
    )
  },
  get: (projectId: string, documentId: string) =>
    request<{ ok: true; document: DocumentRow }>(
      `/api/projects/${encodeURIComponent(projectId)}/documents/${encodeURIComponent(documentId)}`,
    ),
  // Patch 015.A.11 — same-origin URL for the document-content endpoint
  // (`routes/documents.ts` GET .../download). Suitable as an <img>/<a>
  // src; the Cloudflare Access cookie authenticates the same-origin
  // request. A pure URL builder — no fetch.
  downloadUrl: (projectId: string, documentId: string): string =>
    `${BASE}/api/projects/${encodeURIComponent(projectId)}/documents/${encodeURIComponent(documentId)}/download`,
  upload: async (projectId: string, file: File, documentType: string, notes?: string) => {
    const form = new FormData()
    form.append('file', file)
    form.append('document_type', documentType)
    if (notes) form.append('notes', notes)
    const res = await fetch(`${BASE}/api/projects/${encodeURIComponent(projectId)}/documents`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    })
    const body = (await res.json().catch(() => null)) as unknown
    if (!res.ok) {
      const err = (body as { error?: string })?.error ?? `http_${res.status}`
      throw new ApiError(err, res.status, body)
    }
    return body as { ok: true; document: DocumentRow; request_id: string }
  },
  deleteArchive: (projectId: string, documentId: string) =>
    request<{ ok: true; archived_at: string; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/documents/${encodeURIComponent(documentId)}`,
      { method: 'DELETE' },
    ),
}
